module.exports = __webpack_public_path__ + "static/dont-be-evil-8951b11a9200bc922b1b4824019e84ab.jpg";